import useNetwork from './network';
import { IIssuerModel } from './models/issuerModel';

const getIssuers = async (lng: string, roleId: number, provinceId: number) => {
    const { fetchIssuers } = useNetwork();
    const result = await fetchIssuers(lng, roleId, provinceId);

    if (result.status === 200) {
        return (await result.json()) as IIssuerModel[];
    }
};

export default getIssuers;
